/* Collection product carousels — arrow navigation + overflow detection */
(function () {
  'use strict';

  function setupCarousel(carousel) {
    var scroller = carousel.querySelector('[data-cpc-scroller]');
    var prev = carousel.querySelector('[data-cpc-prev]');
    var next = carousel.querySelector('[data-cpc-next]');
    if (!scroller) return;

    function cardStep() {
      var card = scroller.querySelector('.cpc__card');
      if (!card) return scroller.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(scroller.querySelector('.cpc__track')).gap) || 12;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var overflow = scroller.scrollWidth > scroller.clientWidth + 1;
      carousel.setAttribute('data-overflow', overflow ? 'true' : 'false');
      if (!prev || !next) return;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      prev.disabled = scroller.scrollLeft <= 1;
      next.disabled = scroller.scrollLeft >= maxScroll - 1;
    }

    function scrollByCards(direction) {
      var step = cardStep();
      var visible = Math.max(1, Math.floor(scroller.clientWidth / step));
      scroller.scrollBy({ left: direction * step * visible, behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollByCards(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollByCards(1);
      });
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cpc-carousel]').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
